import {
  Component,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reassign-staff',
  templateUrl: './reassign-staff.component.html',
  styleUrls: ['./reassign-staff.component.scss'],
})
export class ReassignStaffComponent implements OnDestroy {
  selectedReassignmentType: any = null;
  showBuildingReassignment = false;
  showRequirementReassignment = false;
  showPrimaryManagerReassignment = false;
  showSecondaryManagerReassignment = false;
  showUserRolesReassignment = false;

  // Note: All workflow-specific properties and methods have been moved to child components
  // This component now only handles the selection view and routing to child components

  // Subscriptions
  private subscriptions: Subscription[] = [];

  reassignmentOptions = [
    {
      icon: 'home_work',
      title: 'New Building',
      description:
        'Add a new building to users, or move users from one building to another.',
    },
    {
      icon: 'person_add',
      title: 'New Primary Manager',
      description: 'Assign a new primary manager to users.',
    },
    {
      icon: 'group_add',
      title: 'New Secondary Manager',
      description: 'Assign a new secondary manager to users.',
    },
    {
      icon: 'build',
      title: 'New Requirement',
      description: 'Assign a new requirement to users.',
    },
    {
      icon: 'admin_panel_settings',
      title: 'User Roles',
      description: 'Assign users to a new role.',
    },
  ];

  selectReassignmentType = (option: any) => {
    this.selectedReassignmentType = option;

    // Reset all workflow flags
    this.showBuildingReassignment = false;
    this.showRequirementReassignment = false;
    this.showPrimaryManagerReassignment = false;
    this.showSecondaryManagerReassignment = false;
    this.showUserRolesReassignment = false;

    if (option.title === 'New Building') {
      this.showBuildingReassignment = true;
    } else if (option.title === 'New Primary Manager') {
      this.showPrimaryManagerReassignment = true;
    } else if (option.title === 'New Secondary Manager') {
      this.showSecondaryManagerReassignment = true;
    } else if (option.title === 'New Requirement') {
      this.showRequirementReassignment = true;
    } else if (option.title === 'User Roles') {
      this.showUserRolesReassignment = true;
    }
  };

  goBack = () => {
    this.selectedReassignmentType = null;
    this.showBuildingReassignment = false;
    this.showRequirementReassignment = false;
    this.showPrimaryManagerReassignment = false;
    this.showSecondaryManagerReassignment = false;
    this.showUserRolesReassignment = false;
    // Child components handle their own reset logic
  };

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
